import {Resource} from 'react-admin';
import React from 'react';
import {Create, Show} from '@api-platform/admin';
import List from './components/views/List';
import ListActions from './components/ListActions';
import {Pagination} from 'react-admin';
import Edit from './components/views/Edit';

export default (resource, api, fieldFactory, inputFactory, parameterFactory) => {
    const {
        create = Create,
        edit = Edit,
        list = List,
        name,
        props,
        show = Show
    } = resource;
    list.defaultProps.pagination = <Pagination rowsPerPageOptions={[]}/>;
    list.defaultProps.perPage = 12;
    list.defaultProps.actions = <ListActions/>;
    edit.defaultProps = { undoable: false };
    resource.readableFields.map(field => {
        if (field.reference) {
            field.fieldProps = {sortable: false}
        }
        return field;
    });

    return (
        <Resource
            {...props}
            key={name}
            create={create}
            edit={edit}
            list={list}
            show={show}
            name={name}
            options={{
                api,
                fieldFactory,
                inputFactory,
                parameterFactory,
                resource,
            }}
        />
    );
};



// WEBPACK FOOTER //
// ./src/ResourceFactory.js